import { createFileRoute } from "@tanstack/react-router";
import { requireAuth } from "@/lib/route-guards";
import UserListPage from "@/components/user-list.tsx";

export const Route = createFileRoute("/_authenticated/users")({
  beforeLoad: requireAuth,
  component: UserListPage,
});